import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto; 
`;

export const PageInformation = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
  margin: 0 auto;
`;

export const AlterPage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 35px;
  width: 230px;
  background: #fff;
  border: 0;
  margin: 0 auto;
`;
